module.exports = "/dist/assets/images/checkbox-checked.svg";